import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=90f2048c&"
import script from "./BaseTabs.vue?vue&type=script&lang=js&"
export * from "./BaseTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports